<script lang="ts" setup>
	const props = defineProps<{
		as?: string | object
		fluid?: boolean
		containerClass?: string | object
	}>()
	let binds = {}
	if (props.fluid)
		binds = {style: '--ui-container: 100vw'}
</script>

<template>
	<component :is="as || 'section'">
		<UContainer v-bind="binds" :class="containerClass">
			<slot />
		</UContainer>
	</component>
</template>
